import React, { useState, useEffect, useContext } from "react";
import { Container, Tabs, Tab, Form, Col, Row, Button, Card, InputGroup, Accordion, Modal, ProgressBar } from "react-bootstrap";
import { Link, redirect, useNavigate, useParams } from "react-router-dom";

import { FaSketch, FaRegHeart } from "react-icons/fa";
import { AiOutlineSketch } from "react-icons/ai";

import { auth, firestore } from "../../database/firebase";
import { storage } from "../../database/firebase";


import { AuthContext } from "../../component_s/Authentication/AuthProvider";

import { BsStarFill, BsStarHalf, BsStar, BsPatchCheck, BsPlayBtn, BsPhone, BsFolder2Open, BsInfinity, BsCheckLg, BsPeopleFill, BsFillPlayBtnFill, BsChatLeftDotsFill, BsPersonCircle, BsCameraReels, BsRecordFill, BsPlusSquareDotted, BsBookmark, BsEye, BsPalette } from "react-icons/bs";


// import "./UploadVideo.css";

import product_sample01 from '../../component_s/images_s/product_sample01.jpeg';
import BookmarkArticle from "./BookmarkArticle";


function MyArticle() {


    let { writerId } = useParams();

    const navigate = useNavigate();

    const refreshPage = () => {
        navigate(0);
    }

    /* TEST QUERY DATA WITH productID */

    // const [uid, setUid] = useState("");

    const [currentUser, setCurrentUser] = useState(null);
    const authContext = useContext(AuthContext);

   //const [uid, setUid] = useState("");

    var user = auth.currentUser;
    // var uid = "";
    var uid = "";

    if (user != null) {
       
        uid = user.uid;  
                     
        console.log(uid);

    } else {
        // navigate("/");
    }
    

   
    ///////////////////////////////////////// Create Article //////////////////////////////////////////
    const articleIDAdd = "arid" + Math.random(999).toString();

    const categoryOption = ["การท่องเที่ยว", "อาหาร", "วิดีโอเกม", "ต้นไม้", "หนังสือ", "คอมพิวเตอร์", "บทความทั่วไป"];
    const [categoryString, setCategoryString] = useState(categoryOption[0]);
    const [categoryType, setCategoryType] = useState("");

    const [subCategoryOption, setSubCategoryOption] = useState(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "ท่องเที่ยวอื่น ๆ"]);
    const [subCategoryString, setSubCategoryString] = useState(subCategoryOption[0]);
    const [subCategoryType, setSubCategoryType] = useState("");

    const [typeCategoryOption, setTypeCategoryOption] = useState(["กรุงเทพมหานคร", "กระบี่", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "เชียงราย", "เชียงใหม่", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พะเยา", "พังงา", "พัทยา", "พัทลุง", "พิจิตร", "พิษณุโลก", "เพชรบุรี", "เพชรบูรณ์", "แพร่", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "แม่ฮ่องสอน", "ยโสธร", "ยะลา", "ร้อยเอ็ด", "ระนอง", "ระยอง", "ราชบุรี", "ลพบุรี", "ลำปาง", "ลำพูน", "เลย", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสาคร", "สมุทรสงคราม", "สระแก้ว", "สระบุรี", "สิงห์บุรี", "สุโขทัย", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "หนองคาย", "หนองบัวลำภู", "อ่างทอง", "อำนาจเจริญ", "อุดรธานี", "อุตรดิตถ์", "อุทัยธานี", "อุบลราชธานี", "การท่องเที่ยงในประเทศไทยอื่น ๆ"]);
    const [typeCategoryString, setTypeCategoryString] = useState(typeCategoryOption[0]);
    const [typeCategoryType, setTypeCategoryType] = useState("");

    const [articleType, setArticleType] = useState(["ทั่วไป", "รีวิว", "คำถาม"]);
    const [articleTypeString, setArticleTypeString] = useState(articleType[0]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    ////////////////ADD ARTICLE NOT LOG IN
    const [showAddArticleNotlogin, setShowAddArticleNotlogin] = useState(false);
    const handleCloseAddArticleNotlogin = () => setShowAddArticleNotlogin(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        // alert(JSON.stringify(formValues));

        if (user == null) {
           
            setShowAddArticleNotlogin(true);
            setShow(false);

        } else {
            const obj = {

                writerID: uid,
                storeName: storeName,

                writerName: writerName,
                writerImg: writerImg,
                writerDescription: writerDescription,
    
                articleID: articleIDAdd,
                articleDate: new Date(),
                articleName: articleNameAdd,
    
                articleCategory: categoryString,
                articleSubCategory: subCategoryString,
                articleTypeCategory: typeCategoryString,
    
                articleHeader: [""],
                articleContent: [""],
                articleContentType: [""],
                articleSection: [""],

                articleRefText: [""],
                articleLinkRefText: [""],
    
                updateCount: 0,
                viewCount: 1,
    
                likeCount: 1,
                userIDLike: [""],
                profileUserImgLike: [""],
                descriptionUserLike: [""],
                displayNameUserLike: [""],
    
                bookmarkCount: 1,
                userIDBookmark: [""],
                profileUserImgBookmark: [""],
                descriptionUserBookmark: [""],
                displayNameUserBookmark: [""],
                
                articleType: articleTypeString,
    
                status: "inprogress",
                publicStatus: "กำลังดำเนินการ",
    
            };
    
            createArticleHandler(obj);

        }
        

 
        
    }


    const createArticleHandler = (obj) => {
           
        const ref = firestore.collection("article");
        ref
            .doc(articleIDAdd)
            .set(obj)
            .then(() => {
                console.log("เพิ่มข้อมูลสำเร็จ");
                navigate("/CreateArticle/" + articleIDAdd)
            })
            .catch((err) => console.log(err));
    };
    ///////////////////////////////////////// Dynamic TypeCategory ////////////////////////////////////

    useEffect(() => {

    if (categoryString == "การท่องเที่ยว") {

        setSubCategoryOption(["การท่องเที่ยวไทย", "การท่องเที่ยเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "การท่องเที่ยวอื่น ๆ"]);
        setSubCategoryString(subCategoryOption[0]);

        setTypeCategoryOption(["กรุงเทพมหานคร", "กระบี่", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "เชียงราย", "เชียงใหม่", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พะเยา", "พังงา", "พัทยา", "พัทลุง", "พิจิตร", "พิษณุโลก", "เพชรบุรี", "เพชรบูรณ์", "แพร่", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "แม่ฮ่องสอน", "ยโสธร", "ยะลา", "ร้อยเอ็ด", "ระนอง", "ระยอง", "ราชบุรี", "ลพบุรี", "ลำปาง", "ลำพูน", "เลย", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสาคร", "สมุทรสงคราม", "สระแก้ว", "สระบุรี", "สิงห์บุรี", "สุโขทัย", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "หนองคาย", "หนองบัวลำภู", "อ่างทอง", "อำนาจเจริญ", "อุดรธานี", "อุตรดิตถ์", "อุทัยธานี", "อุบลราชธานี", "การท่องเที่ยวในประเทศไทยอื่น ๆ"]);
        setTypeCategoryString(typeCategoryOption[0]);

            if (subCategoryString == "การท่องเที่ยวไทย") {

                setSubCategoryOption(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "การท่องเที่ยวอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[0]);

                setTypeCategoryOption(["กรุงเทพมหานคร", "กระบี่", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "เชียงราย", "เชียงใหม่", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พะเยา", "พังงา", "พัทยา", "พัทลุง", "พิจิตร", "พิษณุโลก", "เพชรบุรี", "เพชรบูรณ์", "แพร่", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "แม่ฮ่องสอน", "ยโสธร", "ยะลา", "ร้อยเอ็ด", "ระนอง", "ระยอง", "ราชบุรี", "ลพบุรี", "ลำปาง", "ลำพูน", "เลย", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสาคร", "สมุทรสงคราม", "สระแก้ว", "สระบุรี", "สิงห์บุรี", "สุโขทัย", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "หนองคาย", "หนองบัวลำภู", "อ่างทอง", "อำนาจเจริญ", "อุดรธานี", "อุตรดิตถ์", "อุทัยธานี", "อุบลราชธานี", "การท่องเที่ยวในประเทศไทยอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การท่องเที่ยวเอเชีย") {

                setSubCategoryOption(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "การท่องเที่ยวอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[1]);

                setTypeCategoryOption(["ญี่ปุ่น", "เกาหลีใต้", "จีน", "สิงคโปร์", "เวียดนาม", "มาเลเซีย", "ฟิลิปปินส์", "อินโดนีเซีย", "รัสเซีย", "ออสเตรเลีย", "อินเดีย", "ปากีสถาน", "บังกลาเทศ", "อิหร่าน", "ตุรกี", "พม่า", "อิรัก", "ซาอุดีอาระเบีย", "อุซเบกิสถาน", "เนปาล", "อัฟกานิสถาน", "เยเมน", "เกาหลีเหนือ", "ไต้หวัน", "ศรีลังกา", "ซีเรีย", "คาซัคสถาน", "กัมพูชา", "อาเซอร์ไบจาน", "สหรัฐอาหรับเอมิเรตส์", "ทาจิกิสถาน", "อิสราเอล", "ฮ่องกง", "จอร์แดน", "ลาว",  "คีร์กีซสถาน", "สิงคโปร์", "เติร์กเมนิสถาน", "ปาเลสไตน์", "เลบานอน", "โอมาน", "คูเวต", "จอร์เจีย", "มองโกเลีย", "อาร์มีเนีย", "กาตาร์", "บาห์เรน", "ติมอร์-เลสเต", "ภูฏาน", "มาเก๊า", "บรูไน", "มัลดีฟส์", "การท่องเที่ยวเอเชียอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การท่องเที่ยวยุโรป") {

                setSubCategoryOption(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "การท่องเที่ยวอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[2]);

                setTypeCategoryOption(["รัสเซีย", "เยอรมนี", "ตุรกี", "ฝรั่งเศส", "สหราชอาณาจักร", "อิตาลี", "สเปน", "ยูเครน", "โปแลนด์", "โรมาเนีย", "เนเธอร์แลนด์", "เบลเยียม", "กรีซ", "เช็กเกีย", "โปรตุเกส", "สวีเดน", "ฮังการี", "อาเซอร์ไบจาน", "เบลารุส", "ออสเตรีย", "สวิตเซอร์แลนด์", "เซอร์เบีย", "บัลแกเรีย", "เดนมาร์ก", "ฟินแลนด์", "สโลวาเกีย", "นอร์เวย์", "ไอร์แลนด์","โครเอเชีย", "บอสเนียและเฮอร์เซโกวีนา", "จอร์เจีย", "มอลโดวา", "อาร์มีเนีย", "แอลเบเนีย", "ลิทัวเนีย", "มาซิโดเนียเหนือ", "สโลวีเนีย", "ลัตเวีย", "คอซอวอ", "เอสโตเนีย", "ไซปรัส", "มอนเตเนโกร", "ลักเซมเบิร์ก","มอลตา", "ไอซ์แลนด์", "เจอร์ซีย์ (UK)", "ไอล์ออฟแมน (UK)", "อันดอร์รา", "เกิร์นซีย์ (UK)", "หมู่เกาะแฟโร (Denmark)", "ลีชเทินชไตน์", "โมนาโก", "ยิบรอลตาร์ (UK)", "ซานมารีโน", "หมู่เกาะโอลันด์ (Finland)", "สฟาลบาร์ (Norway)", "นครรัฐวาติกัน", "การท่องเที่ยวยุโรปอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การท่องเที่ยวอเมริกา") {

                setSubCategoryOption(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "การท่องเที่ยวอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[3]);

                setTypeCategoryOption(["สหรัฐอเมริกา", "บราซิล", "เม็กซิโก", "โคลอมเบีย", "อาร์เจนตินา", "แคนาดา", "เปรู", "เวเนซุเอลา", "ชิลี", "เอกวาดอร์", "กัวเตมาลา", "คิวบา", "เฮติ", "โบลิเวีย", "สาธารณรัฐโดมินิกัน", "ฮอนดูรัส", "ปารากวัย", "นิการากัว", "เอลซัลวาดอร์", "คอสตาริกา", "ปานามา", "ปวยร์โตรีโก", "อุรุกวัย", "จาเมกา", "ตรินิแดดและโตเบโก", "กายอานา", "ซูรินาม", "กัวเดอลุป", "มาร์ตีนิก", "บาฮามาส", "เบลีซ", "บาร์เบโดส", "เฟรนช์เกียนา", "เซนต์ลูเชีย", "กูราเซา", "อารูบา", "เซนต์วินเซนต์และเกรนาดีนส์", "หมู่เกาะเวอร์จินของสหรัฐ", "กรีเนดา", "แอนทีกาและบาร์บิวดา", "ดอมินีกา", "เบอร์มิวดา", "หมู่เกาะเคย์แมน", "กรีนแลนด์", "หมู่เกาะเติกส์และเคคอส", "หมู่เกาะบริติชเวอร์จิน", "แองกวิลลา", "แซงปีแยร์และมีเกอลง", "มอนต์เซอร์รัต", "หมู่เกาะฟอล์กแลนด์", "การท่องเที่ยวอเมริกาอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การท่องเที่ยวโอเชียเนีย") {

                setSubCategoryOption(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "การท่องเที่ยวอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[4]);

                setTypeCategoryOption(["ออสเตรเลีย", "ปาปัวนิวกินี", "นิวซีแลนด์", "ฟีจี", "หมู่เกาะโซโลมอน", "วานูวาตู", "นิวแคลิโดเนีย (ฝรั่งเศส)", "เฟรนช์พอลินีเชีย (ฝรั่งเศส)", "ซามัว", "กวม (สหรัฐ)", "คิริบาส", "ตองงา", "ไมโครนีเชีย", "หมู่เกาะมาร์แชลล์", "หมู่เกาะนอร์เทิร์นมาเรียนา (สหรัฐ)", "อเมริกันซามัว (สหรัฐ)", "ปาเลา", "หมู่เกาะคุก (นิวซีแลนด์)", "วอลิสและฟูตูนา (ฝรั่งเศส)", "ตูวาลู", "นาอูรู", "เกาะนอร์ฟอล์ก (ออสเตรเลีย)", "นีวเว (นิวซีแลนด์)", "โตเกเลา (นิวซีแลนด์)", "หมู่เกาะพิตแคร์น (สหราชอาณาจักร)", "การท่องเที่ยวโอเชียเนียอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การท่องเที่ยวแอฟริกา") {

                setSubCategoryOption(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "การท่องเที่ยวอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[5]);

                setTypeCategoryOption(["ไนจีเรีย", "เอธิโอเปีย", "อียิปต์", "สาธารณรัฐประชาธิปไตยคองโก", "แอฟริกาใต้", "แทนซาเนีย", "เคนยา", "ซูดาน", "แอลจีเรีย", "ยูกันดา", "โมร็อกโก", "โมซัมบิก", "กานา", "แองโกลา", "โกตดิวัวร์", "มาดากัสการ์", "แคเมอรูน", "ไนเจอร์", "บูร์กินาฟาโซ", "มาลี", "มาลาวี", "แซมเบีย", "โซมาเลีย", "เซเนกัล", "ชาด", "ซิมบับเว", "ซูดานใต้", "รวันดา", "ตูนิเซีย", "กินี", "เบนิน", "บุรุนดี", "โตโก", "เอริเทรีย", "เซียร์ราลีโอน", "ลิเบีย", "สาธารณรัฐคองโก", "สาธารณรัฐแอฟริกากลาง", "ไลบีเรีย", "มอริเตเนีย", "นามิเบีย", "บอตสวานา", "แกมเบีย", "อิเควทอเรียลกินี", "เลโซโท", "กาบอง", "กินี-บิสเซา", "มอริเชียส", "เอสวาตีนี", "จิบูตี", "เรอูว์นียง", "คอโมโรส", "กาบูเวร์ดี", "มายอต", "เซาตูแมอีปริงซีป", "เซเชลส์", "เซนต์เฮเลนา", "การท่องเที่ยวแอฟริกาอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การท่องเที่ยวอื่น ๆ") {

                setSubCategoryOption(["การท่องเที่ยวไทย", "การท่องเที่ยวเอเชีย", "การท่องเที่ยวยุโรป", "การท่องเที่ยวอเมริกา", "การท่องเที่ยวโอเชียเนีย", "การท่องเที่ยวแอฟริกา", "การท่องเที่ยวอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[6]);

                setTypeCategoryOption(["การท่องเที่ยวอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            }

    } else if (categoryString == "อาหาร") {

        setSubCategoryOption(["อาหารการกิน", "ร้านอาหาร", "การทำอาหาร", "อาหารอื่น ๆ"]);
        setSubCategoryString(subCategoryOption[0]);

        setTypeCategoryOption(["อาหารไทย", "อาหารญี่ปุ่น", "อาหารจีน", "ติ่มซำ", "ก๋วยเตี๋ยว", "ฟาสต์ฟู้ด", "ไอศกรีม", "ของหวาน", "บุฟเฟ่ต์", "ราเมง", "อาหารเช้า", "เครื่องดื่ม", "เค้ก", "เบเกอรี่", "สเต็ก", "อาหารตามสั่ง", "เบอร์เกอร์", "หมูกระทะ", "อาหารทะเล", "สุกี้","ชาบู", "อาหารปิ้งย่าง", "สลัด", "อาหารมังสวิรัติ", "ซูชิ", "พิซซ่า", "โอมากาเสะ", "อาหารอื่น ๆ"]);
        setTypeCategoryString(typeCategoryOption[0]);

            if (subCategoryString == "อาหารการกิน") {

                setSubCategoryOption(["อาหารการกิน", "ร้านอาหาร", "การทำอาหาร", "อาหารอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[0]);

                setTypeCategoryOption(["อาหารไทย", "อาหารญี่ปุ่น", "อาหารจีน", "ติ่มซำ", "ก๋วยเตี๋ยว", "ฟาสต์ฟู้ด", "ไอศกรีม", "ของหวาน", "บุฟเฟ่ต์", "ราเมง", "อาหารเช้า", "เครื่องดื่ม", "เค้ก", "เบเกอรี่", "สเต็ก", "อาหารตามสั่ง", "เบอร์เกอร์", "หมูกระทะ", "อาหารทะเล", "สุกี้","ชาบู", "อาหารปิ้งย่าง", "สลัด", "อาหารมังสวิรัติ", "ซูชิ", "พิซซ่า", "โอมากาเสะ", "อาหารอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "ร้านอาหาร") {

                setSubCategoryOption(["อาหารการกิน", "ร้านอาหาร", "การทำอาหาร", "อาหารอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[1]);

                setTypeCategoryOption(["สตรีทฟู้ด", "ร้านอาหารทั่วไป", "ร้านเครื่องดื่ม", "ร้านอาหารญี่ปุ่น", "ร้านอาหารจีน", "ร้านอาหารไทย", "คาเฟ่", "ห้องอาหารในโรงแรม", "ภัตตาคาร", "สวนอาหาร", "ร้านอาหารอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การทำอาหาร") {

                setSubCategoryOption(["อาหารการกิน", "ร้านอาหาร", "การทำอาหาร", "อาหารอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[2]);

                setTypeCategoryOption(["อาหารไทย", "อาหารญี่ปุ่น", "อาหารจีน", "ติ่มซำ", "ก๋วยเตี๋ยว", "ฟาสต์ฟู้ด", "ไอศกรีม", "ของหวาน", "บุฟเฟ่ต์", "ราเมง", "อาหารเช้า", "เครื่องดื่ม", "เค้ก", "เบเกอรี่", "สเต็ก", "อาหารตามสั่ง", "เบอร์เกอร์", "หมูกระทะ", "อาหารทะเล", "สุกี้","ชาบู", "อาหารปิ้งย่าง", "สลัด", "อาหารมังสวิรัติ", "ซูชิ", "พิซซ่า", "โอมากาเสะ", "อาหารอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "อาหารอื่น ๆ") {

                setSubCategoryOption(["อาหารการกิน", "ร้านอาหาร", "การทำอาหาร", "อาหารอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[3]);

                setTypeCategoryOption(["อาหารอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            }
    } else if (categoryString == "วิดีโอเกม") {

        setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
        setSubCategoryString(subCategoryOption[0]);

        setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
        setTypeCategoryString(typeCategoryOption[0]);

            if (subCategoryString == "เกม PC") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[0]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "เกมมือถือ") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[1]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Nintendo Switch") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[2]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Playstation 5") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[3]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Playstation 4") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[4]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Xbox Series X") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[5]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Steam Deck") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[6]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "ROG Ally") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[7]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Nintendo 3DS") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[8]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Nintendo DS Lite") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[9]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Game Boy") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[10]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "Playstation Portable") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[11]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "เกมอื่น ๆ") {

                setSubCategoryOption(["เกม PC", "เกมมือถือ",  "Nintendo Switch", "Playstation 5", "Playstation 4", "Xbox Series X", "Steam Deck" , "ROG Ally", "Nintendo 3DS", "Nintendo DS Lite", "Game Boy", "Playstation Portable", "เกมอื่น ๆ"]);
                setSubCategoryString(subCategoryOption[12]);

                setTypeCategoryOption(["Action", "RPG", "ARPG", "MMORPG", "Arcade", "Strategy", "MOBA", "Simulation", "Shooting", "Puzzle", "Sport", "Adventure", "Battle Royale", "เกมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            }
    } else if (categoryString == "ต้นไม้") {

        setSubCategoryOption(["ไม้ประดับ", "พืชเศรษฐกิจ", "ต้นไม้อื่น ๆ"]);
        setSubCategoryString(subCategoryOption[0]);

        setTypeCategoryOption(["ไม้ประดับภายในอาคาร", "ไม้ประดับร่มรำไร", "ไม้ประดับกลางแจ้ง", "การจัดสวนขวดแก้ว", "การจัดตู้ไม้น้ำ", "ไม้ยืนต้น", "ไม้พุ่ม", "ไม้ล้มลุก", "ไม้เลื้อย", "ไม้ประดับอื่น ๆ"]);
        setTypeCategoryString(typeCategoryOption[0]);

            if (subCategoryString == "ไม้ประดับ") {

                setSubCategoryOption(["ไม้ประดับ", "พืชเศรษฐกิจ", "ต้นไม้อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[0]);

                setTypeCategoryOption(["ไม้ประดับภายในอาคาร", "ไม้ประดับร่มรำไร", "ไม้ประดับกลางแจ้ง", "การจัดสวนขวดแก้ว", "การจัดตู้ไม้น้ำ", "ไม้ยืนต้น", "ไม้พุ่ม", "ไม้ล้มลุก", "ไม้เลื้อย", "ไม้ประดับอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "พืชเศรษฐกิจ") {

                setSubCategoryOption(["ไม้ประดับ", "พืชเศรษฐกิจ", "ต้นไม้อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[1]);

                setTypeCategoryOption(["ธัญพืช", "พืชน้ำมัน", "พืชน้ำตาล", "พืชเส้นใย", "พืชใช้ใบ", "พืชหัว", "พืชให้ผล", "พืชอาหารสัตว์", "พืชอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "ต้นไม้อื่น ๆ") {

                setSubCategoryOption(["ไม้ประดับ", "พืชเศรษฐกิจ", "ต้นไม้อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[2]);

                setTypeCategoryOption(["ต้นไม้อื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } 
    // 28-10-66 ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    } else if (categoryString == "หนังสือ") {

        setSubCategoryOption(["หนังสือทั่วไป", "หนังสืออ้างอิง", "หนังสืออื่น ๆ"]);
        setSubCategoryString(subCategoryOption[0]);

        setTypeCategoryOption(["นิยายและวรรณกรรม", "วิทยาการและเทคโนโลยี", "ประวัติศาสตร์และวัฒนธรรม", "การศึกษาและการเรียนรู้", "ธุรกิจและการเงิน", "สุขภาพและการดูแลรักษา", "ศาสนาและปรัชญา", "หนังสืออื่น ๆ"]);
        setTypeCategoryString(typeCategoryOption[0]);

            if (subCategoryString == "หนังสือทั่วไป") {

                setSubCategoryOption(["หนังสือทั่วไป", "หนังสืออ้างอิง", "หนังสืออื่น ๆ"]);
                setSubCategoryString(subCategoryOption[0]);

                setTypeCategoryOption(["นิยายและวรรณกรรม", "วิทยาการและเทคโนโลยี", "ประวัติศาสตร์และวัฒนธรรม", "การศึกษาและการเรียนรู้", "ธุรกิจและการเงิน", "สุขภาพและการดูแลรักษา", "ศาสนาและปรัชญา", "หนังสืออื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "หนังสืออ้างอิง") {

                setSubCategoryOption(["หนังสือทั่วไป", "หนังสืออ้างอิง", "หนังสืออื่น ๆ"]);
                setSubCategoryString(subCategoryOption[1]);

                setTypeCategoryOption(["หนังสืออ้างอิง", "หนังสืออ้างอิงอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "หนังสืออื่น ๆ") {

                setSubCategoryOption(["หนังสือทั่วไป", "หนังสืออ้างอิง", "หนังสืออื่น ๆ"]);
                setSubCategoryString(subCategoryOption[2]);

                setTypeCategoryOption(["หนังสืออื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } 
    } else if (categoryString == "คอมพิวเตอร์") {

        setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
        setSubCategoryString(subCategoryOption[0]);

        setTypeCategoryOption(["ภาษา C", "ภาษา C#", "ภาษา C++", "java", "Python", "Go", "javascript", "php", "Swift", "Kotlin", "ภาษาการเขียนโปรแกรมอื่น ๆ"]);
        setTypeCategoryString(typeCategoryOption[0]);

            if (subCategoryString == "ภาษาการเขียนโปรแกรม") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[0]);

                setTypeCategoryOption(["ภาษา C", "ภาษา C#", "ภาษา C++", "java", "Python", "Go", "javascript", "php", "Swift", "Kotlin", "ภาษาการเขียนโปรแกรมอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การพัฒนาเว็บ") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[1]);

                setTypeCategoryOption(["Html", "CSS", "Javascript", "Bootstrap", "React", "React Native", "Vue.js", "Firebase", "php", "ASP.NET Core", "WordPress", "เครื่องมือพัฒนาเว็บ", "การพัฒนาเว็บอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "วิทยาศาสตร์ข้อมูล") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[2]);

                setTypeCategoryOption(["Python", "Machine Learning", "Deep Learning", "Artificial Intelligence", "LangChain", "R", "NLP", "Data Analytics", "วิทยาศาสตร์ข้อมูลอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "วิทยาศาสตร์คอมพิวเตอร์") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[3]);

                setTypeCategoryOption(["วิศวกรรมซอฟแวร์", "สถาปัตยกรรมคอมพิวเตอร์", "โครงสร้างข้อมูลและขั้นตอนวิธี", "คณิตศาสตร์คอมพิวเตอร์ ", "วิทยาศาสตร์คอมพิวเตอร์อื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การพัฒนามือถือ") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[4]);

                setTypeCategoryOption(["Xcode", "Android Studio", "Java", "Swift", "Kotlin", "React Native", "Flutter",  "การพัฒนามือถืออื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "ระบบฐานข้อมูล") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[5]);

                setTypeCategoryOption(["SQL", "MYSQL", "SQL SERVER", "การจัดการฐานข้อมูล", "MongoDB", "PostgreSQL", "Apache Kafka", "Oracle SQL", "Firebase", "ระบบฐานข้อมูลอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "ฮาร์ดแวร์") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[6]);

                setTypeCategoryOption(["ไมโครคอนโทรลเลอร์", "PLC", "Arduino", "Raspberry Pi", "Embedded Systems", "อิเล็กทรอนิกส์", "การซ่อมมือถือ",  "ฮาร์ดแวร์อื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "การออกแบบ") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[7]);

                setTypeCategoryOption(["การออกแบบกราฟฟิก", "Adobe Photoshop", "Adobe Illustrator", "การวาดภาพ", "Canva", "การวาดรูปดิจิทัล", "ทฤษฎีออกแบบ", "Adobe InDesign", "การออกแบบอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else if (subCategoryString == "คอมพิวเตอร์อื่น ๆ") {

                setSubCategoryOption(["ภาษาการเขียนโปรแกรม", "การพัฒนาเว็บ", "วิทยาศาสตร์ข้อมูล", "วิทยาศาสตร์คอมพิวเตอร์", "การพัฒนามือถือ", "ระบบฐานข้อมูล", "ฮาร์ดแวร์", "การออกแบบ", "คอมพิวเตอร์อื่น ๆ"]);
                setSubCategoryString(subCategoryOption[8]);

                setTypeCategoryOption(["คอมพิวเตอร์อื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            }
    } else if (categoryString == "บทความทั่วไป") {

        setSubCategoryOption(["ความรู้ทั่วไป"]);
        setSubCategoryString(subCategoryOption[0]);

        setTypeCategoryOption(["หนังสือ", "การเงิน", "ภาษาศาสตร์", "ความรัก", "การ์ตูน", "วิดีโอเกม", "รถยนต์", "เตรียมสอบ", "กฎหมาย", "คอมพิวเตอร์", "การท่องเที่ยว", "ประวัติศาสตร์", "ความสวยความงาม", "อาหาร", "ต้นไม้", "สัตว์เลี้ยง", "สิ่งมีชีวิต", "ศาสนา", "ดวงชะตา", "ความรู้ทั่วไป", "บทความทั่วไปอื่น ๆ"]);
        setTypeCategoryString(typeCategoryOption[0]);

            if (subCategoryString == "ความรู้ทั่วไป") {

                setSubCategoryOption(["ความรู้ทั่วไป"]);
                setSubCategoryString(subCategoryOption[0]);

                setTypeCategoryOption(["หนังสือ", "การเงิน", "ภาษาศาสตร์", "ความรัก", "การ์ตูน", "วิดีโอเกม", "รถยนต์", "เตรียมสอบ", "กฎหมาย", "คอมพิวเตอร์", "การท่องเที่ยว", "ประวัติศาสตร์", "ความสวยความงาม", "อาหาร", "ต้นไม้", "สัตว์เลี้ยง", "สิ่งมีชีวิต", "ศาสนา", "ดวงชะตา", "ความรู้ทั่วไป", "บทความทั่วไปอื่น ๆ"]);
                setTypeCategoryString(typeCategoryOption[0]);

            } else {

               
            } 
    }

    }, [categoryString, subCategoryString]);

    

    // const [emailDefault, setEmailDefault] = useState("");

    // const [loading, setLoading] = useState(false);
   

    const [articleNameAdd, setArticleNameAdd] = useState("");
    const [writerName, setWriterName] = useState("");
    const [writerDescription, setWriterDescription] = useState("");
    const [writerImg, setWriterImg] = useState("");

    

    const [dataWriter, setDataWriter] = useState([]);
    useEffect(() => {
    const userRef = firestore.collection("user");
    const query = userRef
        
        .where("uid", "==", uid);
            query
            .get()
            .then((querySnapshot) => {
                let tempDataArray =[];
                querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                        console.log(doc.data());
                        tempDataArray = [...tempDataArray,
                        {
                            uid: doc.id,
                            displayName: doc.data().displayName,
                            description: doc.data().description,
                            profileImg: doc.data().profileImg,
                            
                        },
                        
                    ];

                    setWriterName(doc.data().displayName);
                    setWriterDescription(doc.data().description);
                    setWriterImg(doc.data().profileImg);
                    

                    };

                });

            setDataWriter((oldDataArray) => tempDataArray);
            

        },

            (err) => {
                console.log(err);
            }
            
        );

    }, [uid]); 


    //////////////////////////////////// QUERY MY ARTICLE DATA //////////////////////////////////
    const [articleData, setArticleData] = useState([]);
    const [articleID, setArticleID] = useState("");
    // const [merchantID, setMerchantID] = useState("");
    const [writerID, setWriterID] = useState("");
    const [storeName, setStoreName] = useState("");

    //const [writerName, setWriterName] = useState("");

    const [articleName, setArticleName] = useState("");
    const [articleDate, setArticleDate] = useState("");

    const [articleHeader, setArticleHeader] = useState([""]);
    const [articleContent, setArticleContent] = useState([""]);
    const [articleContentType, setArticleContentType] = useState([""]);
    const [articleSection, setArticleSection] = useState([""]);

    

    const [articleCategory, setArticleCategory] = useState("");
    const [articleSubCategory, setArticleSubCategory] = useState("");
    const [articleTypeCategory, setArticleTypeCategory] = useState("");

    const [likeCount, setLikeCount] = useState(0);
    const [bookmarkCount, setBookmarkCount] = useState(0);


    const [updateCount, setUpdateCount] = useState("");
    const [viewCount, setViewCount] = useState("");

    const [publicStatus, setPublicStatus] = useState("");


    //RATING
    const [ratingSum, setRatingSum] = useState(0);
    const [ratingCount, setRatingCount] = useState(0);

    //////////////////////////////////////////////////////
    var courseSectionExArray = [""];

    useEffect(() => {
        const articleRef = firestore.collection("article");
        const query = articleRef
            .orderBy("articleDate", "desc")
            .where("writerID", "==", uid);
                query
                .get()
                .then((querySnapshot) => {
                    let tempDataArray =[];
                    querySnapshot.forEach((doc) => {
                        if (doc.exists) {
                            tempDataArray = [...tempDataArray,
                            {
                                

                                articleID: doc.id,
                                articleID: doc.data().articleID,
                                writerID: doc.data().writerID,
                        

                                writerName: doc.data().writerName,
                                articletName: doc.data().articleName,
                                articleDate: doc.data().articleDate,

                                articleCategory: doc.data().articleCategory,
                                articleSubCategory: doc.data().articleSubCategory,
                                articleTypeCategory: doc.data().articleTypeCategory,

                                articleHeader: doc.data().articleHeader,
                                articleContent: doc.data().articleContent,
                                articleContentType: doc.data().articleContentType,
                                articleSection: doc.data().articleSection,

                                articleBadge: doc.data().articleBadge,

                                updateCount: doc.data().updateCount,
                                viewCount: doc.data().viewCount,

                                likeCount: doc.data().likeCount,
                                bookmarkCount: doc.data().bookmarkCount,

                                publicStatus: doc.data().publicStatus,

                                //RATING
                                /* ratingSum: doc.data().ratingSum,
                                ratingCount: doc.data().ratingCount, */


                            },
                        ];


                        setArticleID(doc.data().articleID);
                        // setMerchantID(doc.data().merchantID);

                        setWriterID(doc.data().writerID);
                        setWriterName(doc.data().writerName);
                        setStoreName(doc.data().storeName);

                        setArticleCategory(doc.data().articleCategory);
                        setArticleSubCategory(doc.data().articleSubCategory);
                        setArticleTypeCategory(doc.data().articleTypeCategory);

                        setArticleName(doc.data().articleName);
                        
                        setArticleHeader(doc.data().articleHeader);
                        setArticleContent(doc.data().articleContent);
                        setArticleContentType(doc.data().articleContentType);
                        setArticleSection(doc.data().articleSection);

                        setUpdateCount(doc.data().updateCount);
                        setViewCount(doc.data().viewCount);

                        setLikeCount(doc.data().likeCount);
              
                        
                        setBookmarkCount(doc.data().bookmarkCount);

                        setPublicStatus(doc.data().publicStatus);


                        /* setRatingSum(doc.data().ratingSum);
                        setRatingCount(doc.data().ratingCount); */

                        };

                        courseSectionExArray.push(doc.data().courseSectionExVideo);
                        console.log(courseSectionExArray);


                    });

                setArticleData((oldDataArray) => tempDataArray);

                
            },

                (err) => {
                    console.log(err);
                }
                
            );

        }, [uid]);



    /* const signOutHandler = () => {
        auth.signOut().then(() => {
            console.log("Log Out Ok");
            setCurrentUser(null);
            navigate("/");
        })
        .catch((err) => {
            console.log("Log Out Not Ok." + err);
        })
    }; */


    ///////////////////////////////////// TEST PUSH DATA TO ARRAY /////////////////////////////////////////////////
   

    /* const signOutHandler = () => {
        auth.signOut().then(() => {
            console.log("Log Out Ok");
            setCurrentUser(null);
            navigate("/");
        })
        .catch((err) => {
            console.log("Log Out Not Ok." + err);
        })
    }; */
   

    return (
        <>
        
        <br/>

        {dataWriter.map((item, index) => {

            return (
                            
                <div key={index}>    

                {/* <form onSubmit={submitHandler}> */}
                                
                    <Container>
                        

                        <h3><strong>บทความของ {writerName}</strong></h3>
             
                    </Container>

                {/* </form> */}
             
                </div>
              
            );
        })}

        <br/>

        <Container>

        <Modal
                show={show} 
                onHide={handleClose} 
                animation={false} 
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Form onSubmit={handleSubmit}>

                <Modal.Header closeButton>
                <Modal.Title>เขียนบทความใหม่</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                
                <Form.Group className="mb-3">
                    <Form.Label>ชื่อบทความ</Form.Label>

                    <Form.Control 
                        type="text"
                        className="rounded-0" 
                        style={{ paddingLeft: 10 }}
                        value={articleNameAdd}
                        onChange={(e) => {
                        setArticleNameAdd(e.target.value);
                        }}
                        placeholder={"*กรุณากรอกชื่อบทความ"}
                        required
                                            
                        />
                        <Form.Control.Feedback type="invalid">
                            ชื่อบทความ
                        </Form.Control.Feedback>
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>หมวดหมู่</Form.Label>
                    

                        <Form.Select className="rounded-0" aria-label="Default select example"
                            onChange={(e) => setCategoryString(e.target.value)}
                            defaultValue={categoryString}
                        >
                            {categoryOption.map((option, index) => (
                            <option key={index}>{option}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>หมวดหมู่ย่อย</Form.Label>
                    

                        <Form.Select className="rounded-0" aria-label="Default select example"
                            onChange={(e) => setSubCategoryString(e.target.value)}
                            defaultValue={subCategoryString}
                        >
                            {subCategoryOption.map((option, index) => (
                            <option key={index}>{option}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>ประเภทหมวดหมู่</Form.Label>
                     

                        <Form.Select className="rounded-0" aria-label="Default select example"
                            onChange={(e) => setTypeCategoryString(e.target.value)}
                            defaultValue={typeCategoryString}
                        >
                            {typeCategoryOption.map((option, index) => (
                            <option key={index}>{option}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>ประเภทบทความ</Form.Label>
                                           
                            <Form.Select className="rounded-0" aria-label="Default select example"
                                onChange={(e) => setArticleTypeString(e.target.value)}
                                defaultValue={articleTypeString}
                            >
                            {articleType.map((option, index) => (
                                <option key={index}>{option}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                   
                
                </Modal.Body>

                <Modal.Footer>
                    
                     <Link to={'/MyArticle/'+ uid} style={{textDecoration: 'none', color: "black"}}>
                        <Button variant="secondary">
                            บทความของฉัน
                        </Button>
                    </Link>
                    <Button variant="success" type="submit">
                        เขียนบทความใหม่
                    </Button>
                </Modal.Footer>

                </Form>

            </Modal>

            <Modal 
                show={showAddArticleNotlogin} 
                onHide={handleCloseAddArticleNotlogin} 
                animation={false} 
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header>
                <Modal.Title>เข้าสู่ระบบ/สมัครสมาชิก</Modal.Title>
                </Modal.Header>
                <Modal.Body><Link to={"/LogIn"} style={{textDecoration: 'none'}}>เข้าสู่ระบบ</Link> หรือ <Link to={"/SignUp"} style={{textDecoration: 'none'}}>สมัครสมาชิก</Link> เพื่อเขียนบทความ</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddArticleNotlogin}>
                        ปิด
                    </Button>
                </Modal.Footer>
            </Modal>

        

        <Tabs defaultActiveKey="บทความของฉัน" id="uncontrolled-tab-example" className="mb-3">
            <Tab eventKey="บทความของฉัน" title="บทความของฉัน">

            <br/>

          
            <h3><strong><BsPalette/> บทความของฉัน</strong><span className="float-end"><Button onClick={() => setShow(true)} className="rounded-0" variant="outline-primary">+ เขียน</Button></span></h3>
         
            <br/>
            <br/>

            {(writerID == "") ? (
                 <>
                    <Col>
                    <Button onClick={() => setShow(true)} variant="link" style={{textDecoration: 'none', color: 'black'}} size="lg">
                        <span style={{fontSize: 100}}><BsPlusSquareDotted/></span><br/><br/><span style={{color: 'blue'}}>เพิ่มบทความ</span>
                    </Button>
                    </Col>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    
                    
                   
                </>
            ) : (
                <></>
            )}

           




            <Row xs={2} md={4} className="g-4">
                

            

            
                {articleData.map((item) => {
                                        
                    return (

                        
                                
                        <div key={item.id}>

                        
                        
                                    <div className='card'>
                                        <Link to={'/CreateArticle/'+ item.articleID} style={{textDecoration: 'none', color: "black"}}>
                                            <Card className="cardarticle">

                                                {!!item.articleContent[0] ? (
                                                    <Card.Img variant="top" class='cardarticledetailimg' src={item.articleContent[0]} />
                                                ) : (
                                                    <Col style={{backgroundColor: '#FFFAFA'}}><div class='cardarticledetailnoimg'><strong>{(item.writerName)}</strong></div></Col>
                                                )}
                                                
                                                
                                                <Card.Body class='cardarticledetail'>
                                                    <Card.Title>
                                                    </Card.Title>

                                                    <p class='articlename' style={{fontWeight: 500}}>{item.articletName}</p>
                                            
                                                    <p class='cardarticledetailnamedatetime'>{item.writerName} <br/> {(item.articleDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})} | {(item.articleDate).toDate().toLocaleTimeString()} 
                                                    <br/>
                                                
                                                    <span class='cardarticledetaillikebookmark'>
                                                        

                                                        <p>
                                                            {item.publicStatus == 'เผยแพร่' ? (
                                                                <>
                                                                    <p><strong><FaRegHeart/> {item.likeCount}</strong> &nbsp;&nbsp;&nbsp;<strong><BsBookmark/> {item.bookmarkCount} &nbsp;&nbsp;&nbsp;<BsEye/> {item.viewCount + 1}</strong>
                                                                    {/* <br/><span style={{color: "green", position: 'relative', top: -10}}>สถานะ : &nbsp;{item.publicStatus}</span></p>   */}
                                                                    </p>
                                                                </>
                                                        
                                                            ) : item.publicStatus == 'หยุดชั่วคราว' ? (
                                                                <>
                                                                    {/* <p><strong><FaRegHeart/> {item.likeCount}</strong> &nbsp;&nbsp;&nbsp;<strong><BsBookmark/> {item.bookmarkCount} &nbsp;&nbsp;&nbsp;<BsEye/> {item.viewCount + 1}</strong>
                                                                    <br/><span style={{color: "salmon", position: 'relative', top: -10}}>สถานะ : &nbsp;{item.publicStatus}</span></p> */}
                                                                    <span style={{color: "salmon", position: 'relative', top: 0}}>สถานะ : &nbsp;{item.publicStatus}</span>
                                                                    
                                                                </>
                                                        
                                                            ) : item.publicStatus == 'กำลังดำเนินการ' ? (
                                                                <>
                                                                    <span style={{color: "salmon", position: 'relative', top: 0}}>สถานะ : &nbsp;{item.publicStatus}</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                </>
                                                            )}
                                                        </p>
                                                    </span></p>


                                                        

                                                </Card.Body>
                                            </Card>
                                        </Link> 
                                    </div>
                       
                                    

                                    



                            

                        </div>

                    )
                })}




        



            </Row>

            <br/>

                
            </Tab>
            <Tab eventKey="บทความที่บันทึก" title="บทความที่บันทึก">

                <BookmarkArticle/>
            </Tab>

            </Tabs>

        
        </Container>
         {/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
        <br/>
        <br/>
      

        </>
    );
}

export default MyArticle;